export const allSharedUrl = "/shared/allShared";
export const exportSharedExcelUrl = "/shared/exportSharedExcel";
